<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Procesy</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Procesy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Procesy</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddProcess" to="/processes/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editProcess"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div
                          v-if="processError('non_field_errors')"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ processError("non_field_errors") }}
                          </span>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis procesu [pl]</h5>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="processObj.description_pl"
                                  />
                                  <div
                                    v-if="processError('description_pl')"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ processError("description_pl") }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis procesu [en]</h5>
                          </div>
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="processObj.description_en"
                                  />
                                  <div
                                    v-if="processError('description_en')"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ processError("description_en") }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis procesu [de]</h5>
                          </div>
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="processObj.description_de"
                                  />
                                  <div
                                    v-if="processError('description_de')"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ processError("description_de") }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis procesu [de_de]</h5>
                          </div>
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      processObj.description_cpde
                                    "
                                  />
                                  <div
                                    v-if="processError('description_cpde')"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ processError("description_cpde") }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis procesu [de_en]</h5>
                          </div>
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      processObj.description_cpen
                                    "
                                  />
                                  <div
                                    v-if="processError('description_cpen')"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ processError("description_cpen") }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Etapy procesu</h5>
                          </div>
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <button
                                v-if="canAddStage"
                                @click="addProcessStage"
                                class="btn btn-primary"
                              >
                                Dodaj
                              </button>
                              <div
                                v-if="processStages.length"
                                class="table-responsive process-stages-table"
                              >
                                <table
                                  class="table table-striped table-bordered"
                                >
                                  <thead>
                                    <tr>
                                      <th style="width: 50px">#</th>
                                      <th>Maszyna</th>
                                      <th>Czynność maszyny</th>
                                      <th style="width: 120px">Akcje</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(item, index) in processStages"
                                      :key="item.pk"
                                      draggable="true"
                                      @dragstart="
                                        onStageDragStart(item, $event)
                                      "
                                      @dragover="onStageDragOver(item, $event)"
                                      @drop="onStageDrop(item, $event)"
                                      @dragend="onStageDragEnd"
                                      :class="{
                                        'drag-over-row':
                                          dragOverStagePk === item.pk,
                                      }"
                                    >
                                      <td
                                        class="drag-handle"
                                        title="Przeciągnij, aby zmienić kolejność"
                                      >
                                        {{ index + 1 }}
                                      </td>
                                      <td>{{ item.machine_name }}</td>
                                      <td>{{ item.machine_action_name }}</td>
                                      <td>
                                        <button
                                          v-if="canChangeStage"
                                          @click="editAction(item)"
                                          class="btn btn-warning btn-xs"
                                        >
                                          <i
                                            class="fa fa-pencil"
                                            aria-hidden="true"
                                          ></i>
                                        </button>
                                        <button
                                          v-if="canDeleteStage"
                                          @click.stop="requestDeleteStage(item)"
                                          class="btn btn-danger btn-xs"
                                        >
                                          <i class="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeProcess"
                                    @click="saveEdit"
                                    :disabled="processSaving"
                                    class="btn btn-primary"
                                  >
                                    {{
                                      processSaving
                                        ? "Zapisywanie..."
                                        : "Zapisz"
                                    }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteProcess"
                      @click.stop="requestDeleteProcess(item)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="confirmDelete"
    @callbackClose="showModal = false"
  />

  <div v-if="mActions" class="modal-dialog abs">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj etap procesu</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-title">
              <h5>Konfiguracja etapu procesu</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Maszyna</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="processStage.machine"
                    mode="single"
                    placeholder="Maszyna"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="machinesPS"
                  >
                  </Multiselect>
                  <div v-if="stageError('machine')" class="has-error">
                    <span class="help-block">
                      {{ stageError("machine") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Czynność maszyny</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="processStage.machine_action"
                    mode="single"
                    placeholder="Czynność maszyny"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="actionsPS"
                  >
                  </Multiselect>
                  <div v-if="stageError('machine_action')" class="has-error">
                    <span class="help-block">
                      {{ stageError("machine_action") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Czas (minut)</label>
                <div class="col-sm-10">
                  <input
                    v-model="processStage.time"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Czas (minut)"
                    required="required"
                  />
                  <div v-if="stageError('time')" class="has-error">
                    <span class="help-block">
                      {{ stageError("time") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Opis etapu procesu [pl]</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="processStage.description_pl"
                  />
                  <div v-if="stageError('description_pl')" class="has-error">
                    <span class="help-block">
                      {{ stageError("description_pl") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Opis etapu procesu [en]</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="processStage.description_en"
                  />
                  <div v-if="stageError('description_en')" class="has-error">
                    <span class="help-block">
                      {{ stageError("description_en") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Opis etapu procesu [de]</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="processStage.description_de"
                  />
                  <div v-if="stageError('description_de')" class="has-error">
                    <span class="help-block">
                      {{ stageError("description_de") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Opis etapu procesu [de_de]</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="processStage.description_cpde"
                  />
                  <div v-if="stageError('description_cpde')" class="has-error">
                    <span class="help-block">
                      {{ stageError("description_cpde") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Opis etapu procesu [de_en]</h5>
            </div>
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="processStage.description_cpen"
                  />
                  <div v-if="stageError('description_cpen')" class="has-error">
                    <span class="help-block">
                      {{ stageError("description_cpen") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ibox-title">
              <h5>Warunki wykonania etapu procesu</h5>
            </div>
            <div class="ibox-content">
              <div v-if="optionsPS" class="col-sm-12">
                <div v-if="preconditionsError" class="has-error">
                  <span class="help-block">{{ preconditionsError }}</span>
                </div>
                <div
                  v-for="(cond, index) in conditions"
                  :key="index"
                  class="form-group row"
                >
                  <!-- The old admin shows the negation toggle only on the
                       stage update form, not when adding a new stage. -->
                  <div v-if="processStage.pk" class="col-sm-2">
                    <button
                      @click="
                        conditions[index].is_not = !conditions[index].is_not
                      "
                      class="btn btn-white"
                      :class="{ condactive: conditions[index].is_not === true }"
                    >
                      Nie
                    </button>
                  </div>
                  <div class="col-sm-8">
                    <Multiselect
                      v-model="conditions[index].precondition"
                      @open="onOptionsDropdownOpen"
                      @search-change="onOptionsSearchChange"
                      mode="single"
                      track-by="name"
                      label="name"
                      :close-on-select="true"
                      :searchable="true"
                      :filter-results="false"
                      :options="optionsPS"
                    >
                    </Multiselect>
                    <div
                      v-if="preconditionError(index, 'precondition')"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ preconditionError(index, "precondition") }}
                      </span>
                    </div>
                  </div>
                  <div class="col-sm-2 text-center">
                    <button class="btn btn-danger btn-block">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <label
                      @click="addConjunction(index, 'and')"
                      :class="{
                        'btn-success': conditions[index].conjunction === 'and',
                      }"
                      class="btn btn-block btn-xs conjunction"
                    >
                      i
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <label
                      @click="addConjunction(index, 'or')"
                      :class="{
                        'btn-success': conditions[index].conjunction === 'or',
                      }"
                      class="btn btn-block btn-xs conjunction"
                    >
                      lub
                    </label>
                  </div>
                  <div
                    v-if="preconditionError(index, 'conjunction')"
                    class="col-sm-12 has-error"
                  >
                    <span class="help-block">
                      {{ preconditionError(index, "conjunction") }}
                    </span>
                  </div>
                </div>
                <button @click="addPreCond" class="btn btn-block btn-primary">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mActions = false" class="btn btn-white">
            Anuluj
          </button>
          <button
            v-if="processStage.pk && canChangeStage"
            @click="updatePS"
            :disabled="stageSaving"
            class="btn btn-primary"
          >
            {{ stageSaving ? "Zapisywanie..." : "Zapisz" }}
          </button>
          <button
            v-else-if="!processStage.pk && canAddStage"
            @click="addPS"
            :disabled="stageSaving"
            class="btn btn-primary"
          >
            {{ stageSaving ? "Dodawanie..." : "Dodaj" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="mActions = false" class="modal-backdrop"></div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import {
  processPermissionsConst,
  processStagePermissionsConst,
} from "../../constants/processConstants";

export default {
  name: "ProcessesList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddProcess = computed(() =>
      hasPermission(processPermissionsConst.add)
    );
    const canChangeProcess = computed(() =>
      hasPermission(processPermissionsConst.update)
    );
    const canDeleteProcess = computed(() =>
      hasPermission(processPermissionsConst.delete)
    );
    // Process stages are a separate model with their own permissions - the old
    // panel gates the nested stages table with processstagePermissionsConst.
    const canAddStage = computed(() =>
      hasPermission(processStagePermissionsConst.add)
    );
    const canChangeStage = computed(() =>
      hasPermission(processStagePermissionsConst.update)
    );
    const canDeleteStage = computed(() =>
      hasPermission(processStagePermissionsConst.delete)
    );
    const deleteProcessesData = computed(
      () => store.getters.getDeleteProcessesData
    );
    const processData = computed(() => store.getters.getProcessData);
    const processStagesData = computed(
      () => store.getters.getProcessStagesData
    );
    const updateProcessesData = computed(
      () => store.getters.getUpdateProcessesData
    );
    const processesData = computed(() => store.getters.getProcessesData);
    const machinesAdminPSData = computed(
      () => store.getters.getMachinesAdminPSData
    );
    const pOptionsAdminPSData = computed(
      () => store.getters.getPOptionsAdminPSData
    );

    const createProcessStagesData = computed(
      () => store.getters.getCreateProcessStagesData
    );

    const editProcessStages = computed(
      () => store.getters.getEditProcessStagesData
    );

    const updateProcessStages = computed(
      () => store.getters.getUpdateProcessStagesData
    );
    const deleteProcessStagesData = computed(
      () => store.getters.getDeleteProcessStagesData
    );

    const processObj = ref({
      description_cpen: "",
      description_de: "",
      description_en: "",
      description_pl: "",
      description_cpde: "",
    });
    let headers = [
      { text: "Nr", value: "pk" },
      {
        text: "Opis",
        value: "description",
        sortable: true,
        search: true,
      },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];
    let stagesHeaders = [
      {
        text: "Maszyna",
        value: "machine_name",
        sortable: true,
        search: true,
      },
      {
        text: "Czynność maszyny",
        value: "machine_action_name",
        sortable: true,
      },

      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let processStages = ref([]);
    const draggedStagePk = ref(null);
    const dragOverStagePk = ref(null);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteType = ref("process");
    const processPk = ref();
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const processStage = ref({
      description_pl: "",
      description_en: "",
      description_de: "",
      description_cpde: "",
      description_cpen: "",
    });
    const isSearch = ref(false);
    const mActions = ref(false);
    const rowsPerPage = ref();
    const machinesPS = ref([]);
    const actionsPS = ref([]);
    const optionsPS = ref([]);
    const isMainOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    // Server side validation errors of both forms, kept as the raw DRF payload
    // ({field: [message, ...]}) and read through the helpers below.
    const processErrors = ref({});
    const stageErrors = ref({});
    const processSaving = ref(false);
    const stageSaving = ref(false);

    // DRF reports field errors as a list of messages, but some validators
    // return a bare string - both shapes have to render.
    const firstError = (errors, field) => {
      const error = errors?.[field];
      if (Array.isArray(error)) {
        return typeof error[0] === "string" ? error[0] : "";
      }
      return typeof error === "string" ? error : "";
    };

    const processError = (field) => firstError(processErrors.value, field);
    const stageError = (field) => firstError(stageErrors.value, field);

    // Errors of the nested precondition serializer come back as a list aligned
    // with the sent rows, e.g. [{}, {precondition: ["..."]}].
    const preconditionError = (index, field) => {
      const errors = stageErrors.value.preconditions;
      if (!Array.isArray(errors)) {
        return "";
      }
      return firstError(errors[index], field);
    };

    // A validation error on the whole collection is reported as plain messages
    // instead, so there is no row to attach it to.
    const preconditionsError = computed(() => {
      const errors = stageErrors.value.preconditions;
      if (typeof errors === "string") {
        return errors;
      }
      if (Array.isArray(errors)) {
        return errors.find((entry) => typeof entry === "string") ?? "";
      }
      return "";
    });

    const conditions = ref([]);
    // Precondition options are fetched page by page from the backend, the
    // select loads the next page once the dropdown is scrolled to the bottom.
    const optionsPSPageSize = 25;
    const optionsPSPage = ref(1);
    const optionsPSQuery = ref("");
    const optionsPSHasNext = ref(false);
    const optionsPSLoading = ref(false);
    let optionsPSSearchTimeout = null;
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });
    const getProcesses = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getProcesses", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteProcess = (pk) => {
      showModal.value = false;
      store.dispatch("deleteProcesses", {
        pk: pk,
      });
    };

    const requestDeleteProcess = (item) => {
      deleteType.value = "process";
      showModal.value = item.pk;
      deleteName.value = item.description;
    };

    const requestDeleteStage = (item) => {
      deleteType.value = "stage";
      showModal.value = item.pk;
      deleteName.value =
        item.machine_action_name || item.machine_name || item.pk;
    };

    const confirmDelete = () => {
      if (deleteType.value === "stage") {
        const stagePk = showModal.value;
        showModal.value = false;

        if (!canDeleteStage.value) {
          return;
        }

        store.dispatch("deleteProcessStages", {
          pk: stagePk,
        });
        return;
      }

      if (!canDeleteProcess.value) {
        showModal.value = false;
        return;
      }

      deleteProcess(showModal.value);
    };
    const saveEdit = () => {
      if (!canChangeProcess.value || processSaving.value) {
        return;
      }

      processErrors.value = {};
      processSaving.value = true;
      store.dispatch("updateProcesses", processObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const loadOptionsPS = (page) => {
      optionsPSLoading.value = true;
      store.dispatch("getPOptionsAdminPS", {
        page: page,
        pageSize: optionsPSPageSize,
        query: optionsPSQuery.value,
      });
    };

    // Labels of the options already picked as preconditions have to be fetched
    // explicitly - they are not necessarily part of the loaded pages.
    const loadSelectedOptionsPS = () => {
      const pks = conditions.value
        .map((cond) => cond.precondition)
        .filter((pk) => pk !== "" && pk !== null && pk !== undefined);

      if (!pks.length) {
        return;
      }

      store.dispatch("getPOptionsAdminPS", {
        pageSize: pks.length,
        pks: pks,
      });
    };

    const onOptionsSearchChange = (query) => {
      const phrase = query || "";
      clearTimeout(optionsPSSearchTimeout);
      optionsPSSearchTimeout = setTimeout(() => {
        if (phrase === optionsPSQuery.value) {
          return;
        }
        optionsPSQuery.value = phrase;
        loadOptionsPS(1);
      }, 400);
    };

    const onOptionsScroll = (event) => {
      const el = event.target;
      if (el.scrollTop + el.clientHeight < el.scrollHeight - 10) {
        return;
      }
      if (!optionsPSHasNext.value || optionsPSLoading.value) {
        return;
      }
      loadOptionsPS(optionsPSPage.value + 1);
    };

    // The dropdown is rendered only while the select is open, so the scroll
    // listener has to be attached on every open.
    const onOptionsDropdownOpen = (select) => {
      setTimeout(() => {
        const scrollContainer = select?.$el?.querySelector(
          ".multiselect-dropdown"
        );
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", onOptionsScroll);
          scrollContainer.addEventListener("scroll", onOptionsScroll);
        }
      }, 100);
    };

    const editProcess = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      processStages.value = [];
      // Errors belong to the process whose form was open, they must not carry
      // over to the row being expanded now.
      processErrors.value = {};
      processSaving.value = false;
      processPk.value = items.value[localIndex].pk;
      store.dispatch("getProcess", { pk: items.value[localIndex].pk });
      store.dispatch("getProcessStages", { pk: items.value[localIndex].pk });
      store.dispatch("getMachinesAdminPS");
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        setTimeout(() => {
          getProcesses();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getProcesses();
    };

    const updateSort = () => {
      search.value = true;
    };

    const addPreCond = () => {
      conditions.value.push({
        precondition: "",
        conjunction: "",
        is_not: false,
      });
    };

    const addConjunction = (index, type) => {
      conditions.value[index].conjunction = type;
    };

    const addPS = () => {
      if (!canAddStage.value || stageSaving.value) {
        return;
      }

      stageErrors.value = {};
      stageSaving.value = true;
      processStage.value.preconditions = conditions.value;
      processStage.value.process = processPk.value;
      store.dispatch("createProcessStages", processStage.value);
    };

    const updatePS = () => {
      if (
        !canChangeStage.value ||
        !processStage.value.pk ||
        stageSaving.value
      ) {
        return;
      }

      stageErrors.value = {};
      stageSaving.value = true;
      processStage.value.preconditions = conditions.value;
      processStage.value.process = processPk.value;
      store.dispatch("updateProcessStages", processStage.value);
    };

    const editAction = (item) => {
      if (!canChangeStage.value) {
        return;
      }

      store.dispatch("getEditProcessStages", item.pk);
    };

    const addProcessStage = () => {
      if (!canAddStage.value) {
        return;
      }

      processStage.value = {};
      conditions.value = [];
      stageErrors.value = {};
      // Drop any phrase left over from a previous edit so the select opens on
      // the unfiltered first page.
      optionsPSQuery.value = "";
      loadOptionsPS(1);
      mActions.value = true;
    };

    const onStageDragStart = (item, event) => {
      draggedStagePk.value = item.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
      }
    };

    const onStageDragOver = (item, event) => {
      event.preventDefault();
      dragOverStagePk.value = item.pk;
    };

    const onStageDragEnd = () => {
      draggedStagePk.value = null;
      dragOverStagePk.value = null;
    };

    // Reordering persists a new position on the stage, so it is an edit.
    const onStageDrop = async (targetItem, event) => {
      event.preventDefault();
      if (
        !canChangeStage.value ||
        !draggedStagePk.value ||
        draggedStagePk.value === targetItem.pk
      ) {
        onStageDragEnd();
        return;
      }

      const fromIndex = processStages.value.findIndex(
        (x) => x.pk === draggedStagePk.value
      );
      const toIndex = processStages.value.findIndex(
        (x) => x.pk === targetItem.pk
      );

      if (fromIndex < 0 || toIndex < 0) {
        onStageDragEnd();
        return;
      }

      const [movedStage] = processStages.value.splice(fromIndex, 1);
      processStages.value.splice(toIndex, 0, movedStage);
      const newPosition = toIndex + 1;

      onStageDragEnd();

      try {
        await store.dispatch("reorderProcessStage", {
          pk: movedStage.pk,
          position: newPosition,
        });
        if (processPk.value) {
          store.dispatch("getProcessStages", { pk: processPk.value });
        }
      } catch (e) {
        if (processPk.value) {
          store.dispatch("getProcessStages", { pk: processPk.value });
        }
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności etapów procesu",
        });
      }
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("processSearchValue") !== null) {
        searchValue.value = localStorage.getItem("processSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getProcesses();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "processSearchValue",
          JSON.stringify(searchValue.value)
        );
        getProcesses();
      },
      { deep: true }
    );

    watch(
      () => processesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => processData.value,
      function (newValue) {
        processObj.value = newValue.data;
      }
    );

    watch(
      () => editProcessStages.value,
      function (newValue) {
        mActions.value = true;
        processStage.value = newValue.data;
        conditions.value = newValue.data.preconditions;
        stageErrors.value = {};
        optionsPSQuery.value = "";
        loadOptionsPS(1);
        loadSelectedOptionsPS();
      }
    );

    watch(
      () => updateProcessStages.value,
      function (newValue) {
        stageSaving.value = false;

        if (newValue?.status === 200) {
          stageErrors.value = {};
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane etapu procesu zaktualizowane!",
          });
          store.dispatch("getProcessStages", { pk: newValue.data.process });
          mActions.value = false;
        } else if (newValue?.status) {
          stageErrors.value = newValue.data ?? {};
          store.dispatch("showToaster", {
            type: "error",
            content:
              newValue.data?.non_field_errors?.[0] ??
              "Nie udało się zaktualizować etapu procesu",
          });
        }
      }
    );

    watch(
      () => deleteProcessesData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Proces został usunięty",
          });
        }
        getProcesses();
      }
    );

    watch(
      () => deleteProcessStagesData.value,
      function (newValue) {
        if (newValue?.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Etap procesu został usunięty",
          });
          if (processPk.value) {
            store.dispatch("getProcessStages", { pk: processPk.value });
          }
        }
      }
    );

    watch(
      () => createProcessStagesData.value,
      function (newValue) {
        stageSaving.value = false;

        if (newValue?.status === 201) {
          stageErrors.value = {};
          mActions.value = false;
          store.dispatch("showToaster", {
            type: "success",
            content: "Dodano nowy etap procesu!",
          });
          // Refresh the stages table of the expanded process, the same way the
          // update path does - otherwise the new stage shows up only after the
          // row is collapsed and expanded again.
          store.dispatch("getProcessStages", { pk: newValue.data.process });
          getProcesses();
        } else if (newValue?.status) {
          // The list is deliberately not reloaded here, that would collapse the
          // expanded row and take the just rendered errors away with it.
          stageErrors.value = newValue.data ?? {};
          store.dispatch("showToaster", {
            type: "error",
            content:
              newValue.data?.non_field_errors?.[0] ??
              "Nie udało się dodać etapu procesu",
          });
        }
      }
    );

    watch(
      () => updateProcessesData.value,
      function (newValue) {
        processSaving.value = false;

        if (newValue?.status === 200) {
          processErrors.value = {};
          getProcesses();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
          // Collapsing the row only makes sense once the data went through,
          // otherwise it would hide the errors that were just rendered.
          cancel();
        } else if (newValue?.status) {
          processErrors.value = newValue.data ?? {};
          store.dispatch("showToaster", {
            type: "error",
            content:
              newValue.data?.non_field_errors?.[0] ??
              "Nie udało się zaktualizować procesu",
          });
        }
      }
    );

    watch(
      () => machinesAdminPSData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          machinesPS.value.push({
            name: "[" + element.pk + "] " + element.name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => pOptionsAdminPSData.value,
      function (newValue) {
        // A `pks` response only resolves labels of the selected options, it
        // must not interfere with the paging of the scrolled list.
        if (!newValue?.pks) {
          optionsPSLoading.value = false;
        }

        if (newValue?.status !== 200) {
          return;
        }

        if (!newValue.pks) {
          optionsPSPage.value = newValue.page || 1;
          optionsPSHasNext.value = Boolean(newValue.data?.next);

          // A fresh first page replaces the list, but the options backing the
          // current selection have to stay so their labels keep rendering.
          if (optionsPSPage.value === 1) {
            const selected = conditions.value.map((cond) => cond.precondition);
            optionsPS.value = optionsPS.value.filter((option) =>
              selected.includes(option.value)
            );
          }
        }

        const loaded = optionsPS.value.map((option) => option.value);
        newValue.data?.results?.forEach((element) => {
          if (loaded.includes(element.pk)) {
            return;
          }
          loaded.push(element.pk);
          optionsPS.value.push({
            name: "[" + element.pk + "] " + element.label,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => processStage.value.machine,
      function (newValue) {
        const index = machinesAdminPSData.value.data.findIndex(
          (obj) => obj.pk === newValue
        );
        if (machinesAdminPSData.value.data[index]?.actions) {
          actionsPS.value = [];
          machinesAdminPSData.value.data[index]?.actions.forEach((element) => {
            actionsPS.value.push({
              name: "[" + element.pk + "] " + element.name,
              value: element.pk,
            });
          });
        }
      }
    );

    watch(
      () => processStagesData.value,
      function (newValue) {
        processStages.value = newValue.data;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getProcesses();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    // Closing the modal drops its errors, and releases the save button in case
    // a request never reported back.
    watch(
      () => mActions.value,
      function (isOpen) {
        if (!isOpen) {
          stageErrors.value = {};
          stageSaving.value = false;
        }
      }
    );

    return {
      headers,
      stagesHeaders,
      items,
      itemsAll,
      loading,
      canAddProcess,
      canChangeProcess,
      canDeleteProcess,
      canAddStage,
      canChangeStage,
      canDeleteStage,
      serverOptions,
      showModal,
      confirmDelete,
      deleteProcess,
      requestDeleteProcess,
      requestDeleteStage,
      deleteName,
      processObj,
      cancel,
      editProcess,
      processStages,
      saveEdit,
      searchValue,
      isSearch,
      rowsPerPage,
      resetFilters,
      updateSort,
      search,
      mActions,
      processStage,
      machinesPS,
      actionsPS,
      addPreCond,
      conditions,
      optionsPS,
      processError,
      stageError,
      preconditionError,
      preconditionsError,
      processSaving,
      stageSaving,
      onOptionsDropdownOpen,
      onOptionsSearchChange,
      addConjunction,
      addPS,
      updatePS,
      editAction,
      addProcessStage,
      onStageDragStart,
      onStageDragOver,
      onStageDrop,
      onStageDragEnd,
      dragOverStagePk,
      selectPage,
      setRowsPerPage,
      isMainOpen,
      chevronMainClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.process-stages-table .drag-handle {
  cursor: move;
  text-align: center;
  color: #676a6c;
}

.process-stages-table .drag-over-row {
  background-color: #f0f8ff;
}
</style>
